import Vue from "vue";
import { Medal } from "@/common/api/leaderboard/Medals";

/** Represents a reactive game state. */
export interface GameState {
  /** The current score */
  score: number;

  /** The distance traveled */
  distance: number;

  /** The medal received */
  medal?: Medal;

  /** The lives left */
  lives: number;

  /** If the game is over */
  gameOver: boolean;

  /** If the game is paused */
  paused: boolean;
}

export interface UIBridge {
  /** Method to call if the instructions were clicked */
  instructionsClicked(): void;

  /** Method to call if the leaderboard was clicked */
  leaderboardClicked(): void;

  /** Method to call when the game has ended */
  gameOver(): void;

  state: GameState;
}

/** Creates a new state */
export function create(
  state: GameState,
  instructionsClicked: () => void,
  leaderboardClicked: () => void,
  gameOver: () => void
): UIBridge {
  return {
    instructionsClicked,
    leaderboardClicked,
    gameOver,
    state
  };
}

export function state(): GameState {
  return Vue.observable<GameState>({
    gameOver: false,
    score: 0,
    distance: 0,
    lives: 0,
    paused: false
  });
}
